import _ from "lodash";
import api from "@/api";

export default {
  namespaced: true,
  state: {
    statuses: []
  },
  getters: {},
  mutations: {
    SET_STATUSES: (state, payload) => (state.statuses = payload)
  },
  actions: {
    getData: async ({ commit }) => {
      // eslint-disable-next-line no-useless-catch
      try {
        const response = await api.get("/providers/project-statuses");
        const statuses = _.get(response, "data.result", []);

        commit("SET_STATUSES", statuses);

        return response;
      } catch (error) {
        throw error;
      }
    }
  }
};
